import { Form } from 'antd';
import { useEffect } from 'react';

import { usePrevious } from '@hook/common/use-previous.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { isExist } from '@util/data/is-exist';

export const useNewWebhookForm = ({ form }: BaseFormInterface) => {
  const unifyApi = Form.useWatch('unifiedApi', form);
  const prevUnifyApi = usePrevious(unifyApi);
  const { enums, events } = useStoreSelector((state) => state.unify.data);

  useEffect(
    () => void (isExist(prevUnifyApi) && prevUnifyApi !== unifyApi && form.resetFields(['events'])),
    [unifyApi, prevUnifyApi],
  );

  return {
    events: isExist(events[unifyApi]) ? events[unifyApi].map(({ name }: any) => ({ label: name, value: name })) : [],
    enums: Object.entries(enums).map(([label, value]) => ({ label, value })),
  };
};
